export default __webpack_public_path__ + "static/media/squads.fde5cb21.svg";